import { PeekSelect, PeekSelectOption, PeekStack, PeekTextField, useTheme } from "@piiqtechnologies/ui-components";
import React, { useMemo } from "react";
import { useIntl } from "react-intl";
import messages from "../messages.i18n";
const CancelFields = ({ row, notesAndReasonsByRequestId, onReasonSelected, onNotesChanged, isAdmin = false, }) => {
    const theme = useTheme();
    const intl = useIntl();
    const { reason, comment, subReason } = useMemo(() => {
        if (!notesAndReasonsByRequestId[row._id]) {
            return {
                reason: "",
                comment: "",
                subReason: "",
            };
        }
        return notesAndReasonsByRequestId[row._id];
    }, [notesAndReasonsByRequestId]);
    const PRE_DEFINED_REASONS = useMemo(() => {
        return [
            intl.formatMessage(messages.reasonSpaceNoLongerAvailable),
            intl.formatMessage(messages.reasonNeedToReschedule),
            intl.formatMessage(messages.reasonNoLongerWantToCapture),
        ];
    }, []);
    const NEED_TO_RESCHEDULE_SUB_REASONS = useMemo(() => {
        const reasons = [
            intl.formatMessage(messages.reasonSpaceNotReady),
            intl.formatMessage(messages.reasonWeatherConditions),
            intl.formatMessage(messages.reasonOfficeClosed),
        ];
        if (isAdmin) {
            reasons.push(intl.formatMessage(messages.reasonScannerNeedsToReschedule));
        }
        return reasons;
    }, [isAdmin]);
    const NO_LONGER_WANT_TO_CAPTURE_SUB_REASONS = useMemo(() => {
        return [
            intl.formatMessage(messages.reasonSpacePreviouslyScanned),
            intl.formatMessage(messages.reasonFloorplanPreviouslyScanned),
            intl.formatMessage(messages.reasonOther),
        ];
    }, []);
    const needToRescheduleText = intl.formatMessage(messages.reasonNeedToReschedule);
    const noLongerWantToCaptureText = intl.formatMessage(messages.reasonNoLongerWantToCapture);
    const otherText = intl.formatMessage(messages.reasonOther);
    const showSubReasonDropdown = reason === needToRescheduleText || reason === noLongerWantToCaptureText;
    const isOtherSubReason = subReason === otherText;
    const subReasons = useMemo(() => {
        if (reason === needToRescheduleText) {
            return NEED_TO_RESCHEDULE_SUB_REASONS;
        }
        if (reason === noLongerWantToCaptureText) {
            return NO_LONGER_WANT_TO_CAPTURE_SUB_REASONS;
        }
        return [];
    }, [reason]);
    return (React.createElement(PeekStack, { direction: "column", width: "calc(100% - 30px)", spacing: theme.spacing(1), m: 1 },
        React.createElement(PeekStack, { direction: "row", spacing: theme.spacing(1) },
            React.createElement(PeekSelect, { value: reason || PRE_DEFINED_REASONS[0], onChange: (e) => onReasonSelected(row._id, e.target.value, ""), sx: { width: showSubReasonDropdown ? "50%" : "calc(100% - 40px)" } }, PRE_DEFINED_REASONS.map((preDefReason) => (React.createElement(PeekSelectOption, { key: preDefReason, value: preDefReason, sx: { justifyContent: "left !important" } }, preDefReason)))),
            showSubReasonDropdown && (React.createElement(PeekSelect, { value: subReason || subReasons[0], onChange: (e) => onReasonSelected(row._id, reason, e.target.value), sx: { width: "50%" } }, subReasons.map((subReasonOption) => (React.createElement(PeekSelectOption, { key: subReasonOption, value: subReasonOption, sx: { justifyContent: "left !important" } }, subReasonOption))))),
            !showSubReasonDropdown && (React.createElement(PeekTextField, { onBlur: (e) => onNotesChanged(row._id, e.target.value), defaultValue: comment, placeholder: "Notes (optional)", sx: {
                    backgroundColor: theme.palette.common.white,
                    borderRadius: "8px",
                    width: "calc(100% - 40px)",
                    ".MuiInputBase-root": {
                        height: "38px",
                        borderRadius: "8px",
                    },
                } }))),
        showSubReasonDropdown && (React.createElement(PeekTextField, { onBlur: (e) => onNotesChanged(row._id, e.target.value), defaultValue: comment, placeholder: isOtherSubReason ? "Notes (required)" : "Notes (optional)", sx: {
                backgroundColor: theme.palette.common.white,
                borderRadius: "8px",
                width: "100%",
                ".MuiInputBase-root": {
                    height: "38px",
                    borderRadius: "8px",
                },
            } }))));
};
export default CancelFields;
